import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterModule } from '@angular/router';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { PlatformService } from '@rma/generic/util/environment';
import { FeatureFlags, FeatureFlagService } from '@rma/generic/util/feature-flags';
import { Request } from 'express';
import { ErrorCardStyle, StandardErrorMessage } from '../domain/error-message';

@Component({
  selector: 'rma-forbidden',
  imports: [RouterModule, MatButtonModule, TranslocoModule],
  templateUrl: './forbidden.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope('fallbackPages')],
  host: {
    class: ErrorCardStyle,
  },
})
export class ForbiddenComponent implements OnInit {
  @Input({ required: true })
  public supportEmail!: string;

  protected forbiddenMessage: string;

  public constructor(
    private readonly featureFlagService: FeatureFlagService,
    private readonly platformService: PlatformService,
    private readonly router: Router,
    @Optional() @Inject(Request) private readonly request: Request,
  ) {
    this.forbiddenMessage = this.router.getCurrentNavigation()?.extras.state?.['errorMessage'] ?? StandardErrorMessage;
  }

  public ngOnInit(): void {
    this.supportEmail = this.featureFlagService.getFeature(FeatureFlags.SupportEmail, 'support@ratemyagent.com.au');

    if (this.platformService.isPlatformServer && this.request.res) {
      this.request.res.status(403);
    }
  }
}
